import {
  TBooleanState,
} from '../../utils/boolean.ts';

const tooltip: Record<TBooleanState, string> = {
  nullish: 'Všetky',
  true: 'Pravda',
  false: 'Nepravda',
};

export default tooltip;
